import { useTranslate } from "@similarweb/i18n-provider";
import { Rocket } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text, Flex } from "@similarweb/ui-components/foundations";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

type Props = {
    signalType: SignalType;
};

const SignalsComingSoonView = ({ signalType }: Props) => {
    const { translate } = useTranslate();

    const automationType = signalType.toLowerCase();

    return (
        <Flex
            data-automation={`signals-${automationType}-coming-soon`}
            flexDirection="column"
            gap="8px"
            alignItems="center"
            justifyContent="center"
        >
            <Rocket
                size="lg"
                color={colorsPalettes.blue[400]}
            />
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[400]}
                textAlign="center"
            >
                {translate(signalsI18nKeys.comingSoonText)}
            </Text>
        </Flex>
    );
};

export default SignalsComingSoonView;
